<template lang="pug">
  v-layout
    v-dialog(v-model="openPopup" fullscreen hide-overlay persistent transition='dialog-bottom-transition')
      v-card
        v-toolbar(dark color='primary')
          v-btn.btn-backspace(outline flat fab small @click="methodClosePopup")
            v-icon keyboard_backspace
          v-toolbar-title
            span(style="color: #ffffff; font-size: 20px;") Mis Seguros
        v-card-text(style="padding: 1em 1.5em;")
          v-layout.box-agente-desktop-formatter(column align-center)
            v-flex(style="margin-top:3em;position:relative")
              v-layout(column)
                v-flex(style="height:150px")
                  v-img
                    img(style="display: flex" :src="iconAgente2")
                v-flex(style="position: absolute;right: -50px;top: 40px;")
                  v-flex.box-text-icon-agente-formatter
                    span(style="color:#ffffff")
                  v-img
                    img(style="display: flex;width:7.5em" :src="nubeTexto")
            v-flex
              v-layout(column)
                v-flex(style="margin-top: 3em;" v-if="nombre")
                  v-layout(row)
                    v-flex(style="max-width: 3em;width: 3em;line-height: 0;")
                      v-img
                        img(:src="iconpersona")
                    v-flex(style="align-self: center;")
                      span(style="font-size: 14px;color: #454A6C;") {{nombre}}
                v-flex(style="margin-top: 2em;" v-if="correo")
                  v-layout(row)
                    v-flex(style="max-width: 3em;width: 3em;line-height: 0;")
                      v-img
                        img(:src="iconCorreo")
                    v-flex(style="align-self: center;")
                      span(style="font-size: 14px;text-decoration-line: underline;color: #0855C4;") {{correo}}
                v-flex(style="margin-top: 2em;" v-if="celular")
                  v-layout(row)
                    v-flex(style="max-width: 3em;width: 3em;line-height: 0;")
                      v-img
                        img(:src="iconCelular")
                    v-flex(style="align-self: center;")
                      span(style="font-size: 14px;color: #454A6C;") {{celular}}

</template>

<script>
import * as d3 from 'd3'
import BoxTitleMonto from '../../components/generic/BoxTitleMonto.vue'

export default {
  props: [
    'correo',
    'celular',
    'nombre',
    'openPopup'
  ],
  data () {
    return {
      iconCelular: require('./../../assets/icons/icon-whatsapp-gris.svg'),
      iconCorreo: require('./../../assets/icons/icon-email-gris.svg'),
      iconpersona: require('./../../assets/icons/icon-person-gris.svg'),
      iconAgente: require('./../../assets/icons-mis-seguros/icon-mi-agente.svg'),
      iconAgente2: require('./../../assets/icons-mis-seguros/icono-mi-agente2.svg'),
      nubeTexto: require('./../../assets/icons-mis-seguros/icono-nube.svg')
    }
  },
  mounted () {
    d3.select('.box-agente-desktop-formatter')
      .style('opacity', '0')
      .transition().duration(300)
      .style('opacity', '1')

    d3.select('.box-text-icon-agente-formatter span')
      .style('opacity', '0')
      .style('font-size', '11px')
      .style('color', '#ffffff')
      .text('Aquí encontrarás los datos de tu asesor')
      .transition().duration(1500)
      .style('opacity', '1')
  },
  methods: {
    methodClosePopup () {
      this.openPopup = false
      this.$emit('closePopup')
    }
  },
  components: {
    BoxTitleMonto
  }
}
</script>

<style scoped>
.box-agente-desktop-formatter .box-text-icon-agente-formatter {
  position: absolute;
  z-index: 1;
  top: 3px;
  left: 8px;
  height: 3em;
  width: 6.5em;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: normal;
  text-align: center;
}

.box-mensaje-agente {
  position: absolute;
  right: -4em;
  top: 1em;
  background: red;
  height: 4em;
  z-index: 1;
  width: 7em;
  padding: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/mis-seguros/PopupMiAgente.vue